var app;

app = window.App || (window.App = {});

app.ProfileImageOverlay = {
  show: function() {
    return $('.profile-image-overlay').addClass('active');
  },
  hide: function() {
    return $('.profile-image-overlay').removeClass('active');
  }
};

$(document).on('click', '.profil-big', app.ProfileImageOverlay.show);

$(document).on('click', '.profile-image-overlay', app.ProfileImageOverlay.hide);
